<template>
  <div class="container" v-if="contact">
    <el-card class="mt-4">
      <h3 class="card-title">
        <strong>{{publicData.username}}</strong>
      </h3>
      <img class="user-image" :src="contact.profilePic|defaultUserPic" width="128" height="128" />
      <!--
      <pre>{{contact}}</pre>
      <pre>{{publicData}}</pre>
      -->
      <div>
        <h5>{{contact.displayName}}</h5>
        Joined Goalpilot {{publicData.createdAt|longDate}}<br />
        <strong>Goalpilot level:</strong> {{publicData.level}} 🥇<br />
        <strong>Job title:</strong> {{publicData.jobTitle}}<br />
        <strong>Online status:</strong> {{contact.isOnline ? 'online' : 'offline'}}<br />
        <template v-if="!contact.isOnline">
          <strong>Last seen:</strong> {{contact.lastSeen|fromNow}}<br />
        </template>
        <strong>Status message:</strong> {{contact.statusMessage}}<br />
        <el-button @click="onShowMessageModal" class="mt-2">Send message</el-button>
      </div>

    </el-card>

    <portal to="modal-target-goal-details">
      <el-dialog :visible.sync="show_message_modal" :title="'Send message to ' + contact.displayName">
        <el-input type="textarea" v-model="message"></el-input>
        <el-button @click="onSendMessage" class="mt-2">Send message</el-button>
      </el-dialog>
    </portal>

    <BugBounty :contact-id="contactId" />

    <el-button @click.prevent="goBack" size="large" class="mt-4">Go back</el-button>
  </div>
</template>

<script>
import BugBounty from '@/components/ContactPage/BugBounty'

// TODO: Send friend request

export default {
  name: 'UserContactPage',
  data() {
    return {
      contactId: null,
      message: '',
      show_message_modal: false,
    };
  },
  watch: {
    $route (to, from) {
      /* check for route change if using <keep-alive>...</keep-alive> */
      if ( to.name === 'user' ) {
        this.setContactToCurrentPath();
      }
    }
  },
  created() {
    this.setContactToCurrentPath();
  },
  computed: {
    // ...mapGetters("project", [
      // "get_goal_by_id"
    // ]),

    publicData() {
      return this.$models.userPublic.subscribeNode( this.contactId )
    },

    contact() {
      return this.$models.userContact.get_contact_by_id( this.contactId )
    },

    // current_goal() {
    //   console.log("contact.currentTask", this.contact.currentTask);
    //   let current_goal = this.get_goal_by_id(this.contact.currentTask);
    //   console.log("current_goal", current_goal);
    //   return current_goal;
    // }

  },
  methods: {
    onShowMessageModal() {
      this.show_message_modal = true;
    },
    setContactToCurrentPath() {
      this.contactId = this.$route.params.userId;
    },

    goBack() {
      this.$router.go(-1);
    },

    onSendMessage() {
      this.$models.userMsgInbox.with({ uid: this.contactId }).add({
        senderUserId: this.$models.user.defaultUserId,
        message: this.message,
      }).then(() => {
        this.message = '';
        this.show_message_modal = false;
        // this.$message('Message sent')
      })
    }
  },
  components: {
    BugBounty,
  }
};
</script>

<style scoped>
.user-image {
  border-radius: 5px;
  margin-right: 20px;
  float: left;
}
</style>
